module.exports = __webpack_public_path__ + "img/colaboracao.355892ba.png";